import { homeSchema } from './schema/homeSchema'
import { informationSchema } from './schema/informationSchema'
import { newsSchema } from './schema/newsSchema'
import { recruitSchema } from './schema/recruitSchema'
import { serviceSchema } from './schema/serviceSchema'

const DOMAIN =
  process.env.NODE_ENV === 'production'
    ? 'https://www.datauniverse.co.kr'
    : 'https://dev-www.datauniverse.co.kr'

export const genarateSeoData = (pathname) => {
  switch (pathname) {
    case '/':
      return {
        title: '데이터유니버스(DataUniverse)',
        description:
          '데이터유니버스는 더 나은 세상을 위해 금융사기, 개인정보유출 등 사회 문제를 정보통신기술(ICT)로 해결해 나아갑니다.',
        url: `${DOMAIN}`,
        schema: homeSchema,
      }
    case '/information':
      return {
        title: '회사 소개 | 데이터유니버스',
        description: '데이터유니버스의 비전, 특허, 인증 내역, 히스토리를 확인해 보세요.',
        url: `${DOMAIN}/information`,
        schema: informationSchema,
      }
    case '/service':
      return {
        title: '서비스 소개 | 데이터유니버스',
        description:
          '데이터유니버스는 스마트피싱보호, 휴대폰분실보호, 휴대폰가족보호, 휴대폰쿠폰지갑, 이벤트유, 오토콜 서비스로 안전하고 편리한 삶을 제공합니다.',
        url: `${DOMAIN}/service`,
        schema: serviceSchema,
      }
    case '/news':
      return {
        title: '뉴스 | 데이터유니버스',
        description: '데이터유니버스의 최신 소식을 확인해 보세요. ',
        url: `${DOMAIN}/news`,
        schema: newsSchema,
      }
    case '/recruit':
      return {
        title: '채용 | 데이터유니버스',
        description: '데이터유니버스의 다닐 맛 나는 복지와 채용 공고를 확인해 보세요.',
        url: `${DOMAIN}/recruit`,
        schema: recruitSchema,
      }
    case '/csr/donation':
      return {
        title: '기부 | 데이터유니버스',
        description:
          '데이터유니버스는 ‘나눔으로 더하는 온기 Warming Lives with Sharing’ 라는 비전 아래 사회 구성원 모두가 행복한 내일을 살아갈 수 있도록 따뜻한 나눔을 실천하고 있습니다.',
        url: `${DOMAIN}/csr/donation`,
        schema: undefined,
      }
    case '/csr/campaign':
      return {
        title: '캠페인 | 데이터유니버스',
        description:
          '데이터유니버스는 보이스피싱 예방을 위한 서비스 개발 뿐 아니라, ‘금융사기 근절’ 을 목표로 다양한 사회 공헌 활동도 활발히 진행하고 있습니다. 수상한 문자나 전화를 수신하였다면 STOP 잠시 멈추고, THINK 생각한 뒤, CONNECT 연락하세요.',
        url: `${DOMAIN}/csr/campaign`,
        schema: undefined,
      }
    default:
      break
  }
}
